<div class="cw-dialog">
    <h2>{{ data.title }}</h2>
    <div class="cw-horizontalline"></div>

    <div class="cw-dialog-content">
        {{ data.message }}
    </div>

    <phscw-input-checkbox
        class="cw-filter-input"
        [editMode]="true"
        name="recommendationCategory"
        inputId="recommendationCategory"
        displayDirection="vertical"
        [checkboxOptions]="employeeData"
        (onChange)="employeeSelected($any($event))">
    </phscw-input-checkbox>

    <div class="mat-dialog-actions cw-dialog-buttons-right">
        <button mat-raised-button color="primary" (click)="clickClose()">{{ 'GENERAL.CANCEL' | translate }}</button>
        <button mat-raised-button color="accent" (click)="clickSubmit()">{{ 'GENERAL.OK' | translate }}</button>
    </div>
</div>
